import { useEffect } from 'react';
import { useLocationStore } from '../stores/locationStore';
import { useManualLocationStore } from '../stores/manualLocationStore';
import { useSystemToolsStore } from '../stores/systemToolsStore';

const MANUAL_SYNC_INTERVAL_MS = 10_000;

export function useManualLocationSync() {
    const featureEnabled = useSystemToolsStore(
        (state) => state.settings?.manual_location_enabled === true,
    );
    const manualModeEnabled = useManualLocationStore((state) => state.manualModeEnabled);
    const coordinate = useManualLocationStore((state) => state.coordinate);
    const syncManualLocation = useLocationStore((state) => state.syncManualLocation);

    useEffect(() => {
        if (!featureEnabled) {
            return;
        }

        if (!manualModeEnabled || !coordinate) {
            return;
        }

        const sendManualLocation = () => {
            void syncManualLocation(coordinate);
        };

        sendManualLocation();

        const intervalId = window.setInterval(sendManualLocation, MANUAL_SYNC_INTERVAL_MS);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [coordinate, featureEnabled, manualModeEnabled, syncManualLocation]);
}
